module.exports = __webpack_public_path__ + "static/year2004-2b43ebafe6b375a8aa2251d26333ffd6.jpg";